export const validateEmptyFields = (fields) => {
  if (fields.userId === "" || fields.password === "") {
    return true;
  }
};

export const validateEmail = (fields) => {
  if (
    fields.emailId === "" ||
    fields.emailId === undefined ||
    fields.emailId === null
  ) {
    return true;
  }
};

export const validatePasswordFields = (fields) => {
  if (fields.currentPassword === "" || fields.newPassword === "") {
    return true;
  }
};

export const validateRegisterForms = (fields) => {
  if (
    fields.firstName === "" ||
    fields.lastName === "" ||
    fields.emailAddress === "" ||
    fields.department === "" ||
    fields.title === ""
  ) {
    return true;
  }
};

export const ValidateRequiredFileds = (fileds) => {
  let isEmpty = false;
  Object.keys(fileds).forEach((filed) => {
    if (
      fileds[filed] === "" ||
      fileds[filed] === null ||
      fileds[filed] === undefined
    ) {
      isEmpty = true;
      return true;
    }
  });
  return isEmpty;
};
